import { EventEmitter,Injectable } from '@angular/core';
import {Room} from '../models/room.model';
import {Floor} from '../models/floor.model';

@Injectable({
  providedIn: 'root'
})
export class InteractionService {

  loadingSpinnerTrigger = new EventEmitter<boolean>();




  sendingRooms = new EventEmitter<Room[]>();






  sendingFloor = new EventEmitter<Floor>();






  triggerSavingRooms = new EventEmitter();



  constructor() { }
}
